import { render, staticRenderFns } from "./PayoutMethodInfo.vue?vue&type=template&id=3f39e46b&scoped=true&"
import script from "./PayoutMethodInfo.vue?vue&type=script&lang=ts&"
export * from "./PayoutMethodInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PayoutMethodInfo.vue?vue&type=style&index=0&id=3f39e46b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39e46b",
  null
  
)

export default component.exports